import React from "react";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { useTranslation } from "react-i18next";

const CustomGridToolbarQuickFilterNew2 = (props) => {
  const { t } = useTranslation();

  return (
    <GridToolbarQuickFilter
      {...props}
      placeholder={t("common.search")}
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#D0D5DD" }} />
          </InputAdornment>
        ),
      }}
      sx={{
        width: "100%",
        margin: 0,
        padding: 0,
        display: "flex",
        alignItems: "center",
        "& .MuiInputBase-root": {
          borderRadius: "8px",
          backgroundColor: "#FEFEFE",
          height: "40px",
          minHeight: "40px",
          boxSizing: "border-box",
          width: "100%",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#E5E7EB",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#E5E7EB",
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#E5E7EB",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#000000",
        },
        ...props.sx,
      }}
    />
  );
};

export default CustomGridToolbarQuickFilterNew2;
